import { Asset, SharingLink, TotalInfo } from '../../api';
import { routes } from '../router/model';
import { generatePath } from 'react-router-dom';
import { Loading } from '../finder/model';

export type SharingShape = {
  sharingId: SharingLink['id'] | undefined;
  data: { assets: Asset[]; total: TotalInfo; sharing_link: SharingLink | null };
  hasNextPage: boolean;
  scrollHash: string;
  loading: Loading;
  shareInProgress: ShareInProgress;
  isReplacingPack: boolean;
};

export enum ShareContext {
  pack = 'pack',
  asset = 'asset',
  allAssets = 'allAssets',
  sharing = 'sharing',
}

export type ShareInProgress = {
  [ShareContext.pack]: boolean;
  [ShareContext.asset]: Partial<Record<Asset['id'], boolean>>;
  [ShareContext.allAssets]: boolean;
  [ShareContext.sharing]: Partial<Record<SharingLink['id'], boolean>>;
};

export const createHref = (sharingId: SharingLink['id']) => {
  const url = new URL(window.location.href);
  for (const [key] of url.searchParams) {
    url.searchParams.delete(key);
  }
  url.hash = generatePath(routes.sharing, { sharingId });
  return url.href;
};
